<template>
  <div class="layout-wrap">
    <Loading />
    <ToExternalPlanInfoDialog/>
    <GuideModal 
      :isVisible="isGuideModalVisible" 
      :constructionId="currentConstructionId"
      @close="closeGuideModal" 
    />
    <div class="nav-wrap" @wheel="onGlobalWheel">
      <nav class="sidebar">
        <router-link :to="{ name: 'ConstructionList' }" class="name" data-title="工事一覧">
          <div class="sidebar-item">
            <span class="icon cloud-info"></span>
          </div>
        </router-link>
        <router-link :to="{ name: 'KuraemonLiveList' }" class="name" data-title="カメラ一覧">
          <div class="sidebar-item active">
            <span class="icon video-info"></span>
            <span class="label">カメラ</span>
          </div>
        </router-link>
        
        <!-- <div class="sidebar-item">
          <span class="icon">❤️</span>
          <span class="label">バイタル</span>
        </div>
        <div class="sidebar-item">
          <span class="icon">📋</span>
          <span class="label">報告</span>
        </div>
         -->
        <!-- スペーサー：カメラとアカウントアイコンの間の余白 -->
        <div class="spacer"></div>
        <!-- ヒントアイコン -->
        <div class="sidebar-item bottom" @click="showGuideModal">
          <span class="icon hint-info"></span>
          <span class="label">ヒント</span>
        </div>
        <!-- アカウントアイコン -->
        <div class="sidebar-item bottom account-icon">
          <div class="diagonal-stripe"></div>
          <div class="icon account-avatar" :title="accountName">
            <img v-if="accountIconUrl" :src="accountIconUrl" :alt="accountName" />
          </div>
        </div>
      </nav>
    </div>
    <div class="front-wrap">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SideServiceLayout',
}
</script>

<script setup lang="ts">
  import { defineAsyncComponent, computed, onMounted, ref } from 'vue'
  import { useConstructionStore } from "@/stores/construction"
  import { useAccountStore } from "@/stores/account"
  import { useLoginStore } from "@/stores/login"
  import { useRoute } from 'vue-router'
  // components
  const route = useRoute()
  const ToExternalPlanInfoDialog = defineAsyncComponent(() => import('@/components/cloud/notification/ToExternalPlanInfoDialog.vue'))
  const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))
  const GuideModal = defineAsyncComponent(() => import('@/components/cloud/live/GuideModal.vue'))
  const constructionStore = useConstructionStore()
  const accountStore = useAccountStore()
  const loginStore = useLoginStore()

  // ガイドモーダルの状態管理
  const isGuideModalVisible = ref(false)
  
  // 現在の工事IDを取得
  const currentConstructionId = computed(() => {
    // ルートパラメータから取得
    if (route.params.cloudConstructionId) {
      return route.params.cloudConstructionId as string
    }
    // クエリパラメータから取得
    if (route.query.construction_id) {
      return route.query.construction_id as string
    }
    // ストアから取得
    if (constructionStore.cloudConstructionInfo?.cloud_construction_id) {
      return constructionStore.cloudConstructionInfo.cloud_construction_id
    }
    return undefined
  })
  
  const showGuideModal = () => {
    isGuideModalVisible.value = true
  }
  
  const closeGuideModal = () => {
    isGuideModalVisible.value = false
  }

  // アカウント情報の取得
  const currentAccount = computed(() => loginStore.currentAccount)
  const accountDetailInfo = computed(() => accountStore.accountDetailInfo)
  
  // アカウントアイコンのURL取得
  const accountIconUrl = computed(() => {
    if (accountDetailInfo.value?.icon_url) {
      return accountDetailInfo.value.icon_url
    }
    // currentAccountからicon_urlを取得することも可能
    if (currentAccount.value?.icon_url) {
      return currentAccount.value.icon_url
    }
    // デフォルトアイコンまたはアカウント名の初期文字
    return null
  })

  // アカウント名の取得
  const accountName = computed(() => {
    return currentAccount.value?.account_name || ''
  })

  onMounted(async () => {
    // アカウント詳細情報を取得
    await accountStore.getAccountInfo({})
  })

  if(route.params.cloudConstructionId){
    const args = {
      cloud_construction_id: route.params.cloudConstructionId as string,
      __apiOptions: { noStore: true, noErrorDialog: true }
    }
    constructionStore.getCloudConstruction(args)
  }

  // ===================== Global Wheel Handler =====================
  const ua = navigator.platform || navigator.userAgent || "";
  const isMacOS = /mac/i.test(ua);
  function onGlobalWheel(e: WheelEvent) {
    const modifierPressed = isMacOS ? e.metaKey : e.ctrlKey;
    if (!modifierPressed) return;
    e.preventDefault();
  }
</script>

<style scoped>
.layout-wrap {
  display: flex;
  height: 100vh;
  background-color: #f0f0f0;
  .nav-wrap {
    width: 65px;
    min-width: 65px;
    max-width: 65px;
    flex-shrink: 0;
    background-color: #0E1C77;
    .sidebar {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;
      height: 100vh;

      .name {
        width: 100%;
        text-decoration: none;
        color: white;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }

      .spacer {
        flex: 1;
        min-height: 20px;
      }

      .sidebar-item {
        width: 100%;
        text-align: center;
        cursor: pointer;
        border-bottom: #f0f0f0 1px solid;
        height: 65px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: background-color 0.2s ease;
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        .icon {
          width: 43px;
          height: 43px;
          font-size: 20px;
          display: block;
        }
        .cloud-info{
          background: url('@/assets/icons/kuraemon_cloud.svg') center center no-repeat;
          background-size: contain;
          margin: auto auto;
        }
        .video-info{
          background: url('@/assets/icons/live/video.svg') center center no-repeat;
          background-size: contain;
          margin: 0 auto;
          width: 40px;
          height: 40px;
        }
        .hint-info{
          background: url('@/assets/icons/hint.svg') center center no-repeat;
          background-size: contain;
          margin: 0 auto;
          width: 28px;
          height: 40px;
        }
        .label {
          font-size: 11px;
          font-weight: 900;
          position: relative;
          top: -5px;
          font-family: "メイリオ";
        }
        &.active{
          background-color: #6E77AE;
          
          &:hover {
            background-color: rgba(110, 119, 174, 0.8);
          }
        }
        
        &.bottom {
          border-top: 1px solid #f0f0f0;
          border-bottom: none;
        }
        
        &.account-icon {
          position: relative;
          overflow: hidden;
          
          .diagonal-stripe {
            position: absolute;
            top: -10px;
            left: -33px;
            width: 50px;
            height: 12px;
            background-color: #FFD700;
            transform: rotate(-45deg);
            transform-origin: 100% 0;
            z-index: 3;
          }
          
          .account-avatar {
            position: relative;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            border: 4px solid #ffffff;
            overflow: hidden;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            
            & img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              position: relative;
              z-index: 1;
            }
            
          }
        }
      }
    }
  }
  .front-wrap {
    height: 100%;
    overflow-y: scroll;
    width: 100%;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
}
</style>